/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as SignInRouteImport } from './routes/sign-in'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index'
import { Route as AuthenticatedAuditLogRouteImport } from './routes/_authenticated/audit-log'
import { Route as AuthenticatedChangelogRouteImport } from './routes/_authenticated/changelog'
import { Route as AuthenticatedDiscordRouteImport } from './routes/_authenticated/discord'
import { Route as AuthenticatedEventCategoriesRouteImport } from './routes/_authenticated/event-categories'
import { Route as AuthenticatedFeatureRequestsRouteImport } from './routes/_authenticated/feature-requests'
import { Route as AuthenticatedMailRouteImport } from './routes/_authenticated/mail'
import { Route as AuthenticatedProfileRouteImport } from './routes/_authenticated/profile'
import { Route as AuthenticatedAboutIndexRouteImport } from './routes/_authenticated/about/index'
import { Route as AuthenticatedAboutCategoryIdRouteImport } from './routes/_authenticated/about/$categoryId'
import { Route as AuthenticatedCheckinsIndexRouteImport } from './routes/_authenticated/checkins/index'
import { Route as AuthenticatedEventsIndexRouteImport } from './routes/_authenticated/events/index'
import { Route as AuthenticatedEventsEventIdRouteImport } from './routes/_authenticated/events/$eventId'
import { Route as AuthenticatedEventsNewRouteImport } from './routes/_authenticated/events/new'
import { Route as AuthenticatedMediaAssetsRouteImport } from './routes/_authenticated/media/assets'
import { Route as AuthenticatedPersonsIndexRouteImport } from './routes/_authenticated/persons/index'
import { Route as AuthenticatedPersonsFansRouteImport } from './routes/_authenticated/persons/fans'
import { Route as AuthenticatedPersonsUsersRouteImport } from './routes/_authenticated/persons/users'
import { Route as AuthenticatedReservationsIndexRouteImport } from './routes/_authenticated/reservations/index'
import { Route as AuthenticatedSettingsIndexRouteImport } from './routes/_authenticated/settings/index'
import { Route as AuthenticatedTicketsIndexRouteImport } from './routes/_authenticated/tickets/index'
import { Route as AuthenticatedUsersIndexRouteImport } from './routes/_authenticated/users/index'
import { Route as AuthenticatedUsersUserIdRouteImport } from './routes/_authenticated/users/$userId'
import { Route as AuthenticatedWebsiteIndexRouteImport } from './routes/_authenticated/website/index'
import { Route as AuthenticatedWebsitePageIdRouteImport } from './routes/_authenticated/website/$pageId'
import { Route as AuthenticatedWebsiteNavigationRouteImport } from './routes/_authenticated/website/navigation'
import { Route as AuthenticatedWebsitePageIdIndexRouteImport } from './routes/_authenticated/website/$pageId/index'
import { Route as AuthenticatedWebsitePageIdSectionIdRouteImport } from './routes/_authenticated/website/$pageId/$sectionId'

const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const SignInRoute = SignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAuditLogRoute = AuthenticatedAuditLogRouteImport.update({
  id: '/audit-log',
  path: '/audit-log',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedChangelogRoute = AuthenticatedChangelogRouteImport.update({
  id: '/changelog',
  path: '/changelog',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedDiscordRoute = AuthenticatedDiscordRouteImport.update({
  id: '/discord',
  path: '/discord',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedEventCategoriesRoute =
  AuthenticatedEventCategoriesRouteImport.update({
    id: '/event-categories',
    path: '/event-categories',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedFeatureRequestsRoute =
  AuthenticatedFeatureRequestsRouteImport.update({
    id: '/feature-requests',
    path: '/feature-requests',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedMailRoute = AuthenticatedMailRouteImport.update({
  id: '/mail',
  path: '/mail',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedProfileRoute = AuthenticatedProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAboutIndexRoute = AuthenticatedAboutIndexRouteImport.update({
  id: '/about/',
  path: '/about/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAboutCategoryIdRoute =
  AuthenticatedAboutCategoryIdRouteImport.update({
    id: '/about/$categoryId',
    path: '/about/$categoryId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCheckinsIndexRoute =
  AuthenticatedCheckinsIndexRouteImport.update({
    id: '/checkins/',
    path: '/checkins/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedEventsIndexRoute =
  AuthenticatedEventsIndexRouteImport.update({
    id: '/events/',
    path: '/events/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedEventsEventIdRoute =
  AuthenticatedEventsEventIdRouteImport.update({
    id: '/events/$eventId',
    path: '/events/$eventId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedEventsNewRoute = AuthenticatedEventsNewRouteImport.update({
  id: '/events/new',
  path: '/events/new',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedMediaAssetsRoute =
  AuthenticatedMediaAssetsRouteImport.update({
    id: '/media/assets',
    path: '/media/assets',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPersonsIndexRoute =
  AuthenticatedPersonsIndexRouteImport.update({
    id: '/persons/',
    path: '/persons/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPersonsFansRoute =
  AuthenticatedPersonsFansRouteImport.update({
    id: '/persons/fans',
    path: '/persons/fans',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPersonsUsersRoute =
  AuthenticatedPersonsUsersRouteImport.update({
    id: '/persons/users',
    path: '/persons/users',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedReservationsIndexRoute =
  AuthenticatedReservationsIndexRouteImport.update({
    id: '/reservations/',
    path: '/reservations/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSettingsIndexRoute =
  AuthenticatedSettingsIndexRouteImport.update({
    id: '/settings/',
    path: '/settings/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedTicketsIndexRoute =
  AuthenticatedTicketsIndexRouteImport.update({
    id: '/tickets/',
    path: '/tickets/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedUsersIndexRoute = AuthenticatedUsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedUsersUserIdRoute =
  AuthenticatedUsersUserIdRouteImport.update({
    id: '/users/$userId',
    path: '/users/$userId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedWebsiteIndexRoute =
  AuthenticatedWebsiteIndexRouteImport.update({
    id: '/website/',
    path: '/website/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedWebsitePageIdRoute =
  AuthenticatedWebsitePageIdRouteImport.update({
    id: '/website/$pageId',
    path: '/website/$pageId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedWebsiteNavigationRoute =
  AuthenticatedWebsiteNavigationRouteImport.update({
    id: '/website/navigation',
    path: '/website/navigation',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedWebsitePageIdIndexRoute =
  AuthenticatedWebsitePageIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedWebsitePageIdRoute,
  } as any)
const AuthenticatedWebsitePageIdSectionIdRoute =
  AuthenticatedWebsitePageIdSectionIdRouteImport.update({
    id: '/$sectionId',
    path: '/$sectionId',
    getParentRoute: () => AuthenticatedWebsitePageIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthenticatedIndexRoute
  '/sign-in': typeof SignInRoute
  '/audit-log': typeof AuthenticatedAuditLogRoute
  '/changelog': typeof AuthenticatedChangelogRoute
  '/discord': typeof AuthenticatedDiscordRoute
  '/event-categories': typeof AuthenticatedEventCategoriesRoute
  '/feature-requests': typeof AuthenticatedFeatureRequestsRoute
  '/mail': typeof AuthenticatedMailRoute
  '/profile': typeof AuthenticatedProfileRoute
  '/about/$categoryId': typeof AuthenticatedAboutCategoryIdRoute
  '/events/$eventId': typeof AuthenticatedEventsEventIdRoute
  '/events/new': typeof AuthenticatedEventsNewRoute
  '/media/assets': typeof AuthenticatedMediaAssetsRoute
  '/persons/fans': typeof AuthenticatedPersonsFansRoute
  '/persons/users': typeof AuthenticatedPersonsUsersRoute
  '/users/$userId': typeof AuthenticatedUsersUserIdRoute
  '/website/$pageId': typeof AuthenticatedWebsitePageIdRouteWithChildren
  '/website/navigation': typeof AuthenticatedWebsiteNavigationRoute
  '/about/': typeof AuthenticatedAboutIndexRoute
  '/checkins/': typeof AuthenticatedCheckinsIndexRoute
  '/events/': typeof AuthenticatedEventsIndexRoute
  '/persons/': typeof AuthenticatedPersonsIndexRoute
  '/reservations/': typeof AuthenticatedReservationsIndexRoute
  '/settings/': typeof AuthenticatedSettingsIndexRoute
  '/tickets/': typeof AuthenticatedTicketsIndexRoute
  '/users/': typeof AuthenticatedUsersIndexRoute
  '/website/': typeof AuthenticatedWebsiteIndexRoute
  '/website/$pageId/$sectionId': typeof AuthenticatedWebsitePageIdSectionIdRoute
  '/website/$pageId/': typeof AuthenticatedWebsitePageIdIndexRoute
}
export interface FileRoutesByTo {
  '/sign-in': typeof SignInRoute
  '/audit-log': typeof AuthenticatedAuditLogRoute
  '/changelog': typeof AuthenticatedChangelogRoute
  '/discord': typeof AuthenticatedDiscordRoute
  '/event-categories': typeof AuthenticatedEventCategoriesRoute
  '/feature-requests': typeof AuthenticatedFeatureRequestsRoute
  '/mail': typeof AuthenticatedMailRoute
  '/profile': typeof AuthenticatedProfileRoute
  '/': typeof AuthenticatedIndexRoute
  '/about/$categoryId': typeof AuthenticatedAboutCategoryIdRoute
  '/events/$eventId': typeof AuthenticatedEventsEventIdRoute
  '/events/new': typeof AuthenticatedEventsNewRoute
  '/media/assets': typeof AuthenticatedMediaAssetsRoute
  '/persons/fans': typeof AuthenticatedPersonsFansRoute
  '/persons/users': typeof AuthenticatedPersonsUsersRoute
  '/users/$userId': typeof AuthenticatedUsersUserIdRoute
  '/website/navigation': typeof AuthenticatedWebsiteNavigationRoute
  '/about': typeof AuthenticatedAboutIndexRoute
  '/checkins': typeof AuthenticatedCheckinsIndexRoute
  '/events': typeof AuthenticatedEventsIndexRoute
  '/persons': typeof AuthenticatedPersonsIndexRoute
  '/reservations': typeof AuthenticatedReservationsIndexRoute
  '/settings': typeof AuthenticatedSettingsIndexRoute
  '/tickets': typeof AuthenticatedTicketsIndexRoute
  '/users': typeof AuthenticatedUsersIndexRoute
  '/website': typeof AuthenticatedWebsiteIndexRoute
  '/website/$pageId/$sectionId': typeof AuthenticatedWebsitePageIdSectionIdRoute
  '/website/$pageId': typeof AuthenticatedWebsitePageIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/sign-in': typeof SignInRoute
  '/_authenticated/audit-log': typeof AuthenticatedAuditLogRoute
  '/_authenticated/changelog': typeof AuthenticatedChangelogRoute
  '/_authenticated/discord': typeof AuthenticatedDiscordRoute
  '/_authenticated/event-categories': typeof AuthenticatedEventCategoriesRoute
  '/_authenticated/feature-requests': typeof AuthenticatedFeatureRequestsRoute
  '/_authenticated/mail': typeof AuthenticatedMailRoute
  '/_authenticated/profile': typeof AuthenticatedProfileRoute
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/_authenticated/about/$categoryId': typeof AuthenticatedAboutCategoryIdRoute
  '/_authenticated/events/$eventId': typeof AuthenticatedEventsEventIdRoute
  '/_authenticated/events/new': typeof AuthenticatedEventsNewRoute
  '/_authenticated/media/assets': typeof AuthenticatedMediaAssetsRoute
  '/_authenticated/persons/fans': typeof AuthenticatedPersonsFansRoute
  '/_authenticated/persons/users': typeof AuthenticatedPersonsUsersRoute
  '/_authenticated/users/$userId': typeof AuthenticatedUsersUserIdRoute
  '/_authenticated/website/$pageId': typeof AuthenticatedWebsitePageIdRouteWithChildren
  '/_authenticated/website/navigation': typeof AuthenticatedWebsiteNavigationRoute
  '/_authenticated/about/': typeof AuthenticatedAboutIndexRoute
  '/_authenticated/checkins/': typeof AuthenticatedCheckinsIndexRoute
  '/_authenticated/events/': typeof AuthenticatedEventsIndexRoute
  '/_authenticated/persons/': typeof AuthenticatedPersonsIndexRoute
  '/_authenticated/reservations/': typeof AuthenticatedReservationsIndexRoute
  '/_authenticated/settings/': typeof AuthenticatedSettingsIndexRoute
  '/_authenticated/tickets/': typeof AuthenticatedTicketsIndexRoute
  '/_authenticated/users/': typeof AuthenticatedUsersIndexRoute
  '/_authenticated/website/': typeof AuthenticatedWebsiteIndexRoute
  '/_authenticated/website/$pageId/$sectionId': typeof AuthenticatedWebsitePageIdSectionIdRoute
  '/_authenticated/website/$pageId/': typeof AuthenticatedWebsitePageIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/sign-in'
    | '/audit-log'
    | '/changelog'
    | '/discord'
    | '/event-categories'
    | '/feature-requests'
    | '/mail'
    | '/profile'
    | '/about/$categoryId'
    | '/events/$eventId'
    | '/events/new'
    | '/media/assets'
    | '/persons/fans'
    | '/persons/users'
    | '/users/$userId'
    | '/website/$pageId'
    | '/website/navigation'
    | '/about/'
    | '/checkins/'
    | '/events/'
    | '/persons/'
    | '/reservations/'
    | '/settings/'
    | '/tickets/'
    | '/users/'
    | '/website/'
    | '/website/$pageId/$sectionId'
    | '/website/$pageId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/sign-in'
    | '/audit-log'
    | '/changelog'
    | '/discord'
    | '/event-categories'
    | '/feature-requests'
    | '/mail'
    | '/profile'
    | '/'
    | '/about/$categoryId'
    | '/events/$eventId'
    | '/events/new'
    | '/media/assets'
    | '/persons/fans'
    | '/persons/users'
    | '/users/$userId'
    | '/website/navigation'
    | '/about'
    | '/checkins'
    | '/events'
    | '/persons'
    | '/reservations'
    | '/settings'
    | '/tickets'
    | '/users'
    | '/website'
    | '/website/$pageId/$sectionId'
    | '/website/$pageId'
  id:
    | '__root__'
    | '/_authenticated'
    | '/sign-in'
    | '/_authenticated/audit-log'
    | '/_authenticated/changelog'
    | '/_authenticated/discord'
    | '/_authenticated/event-categories'
    | '/_authenticated/feature-requests'
    | '/_authenticated/mail'
    | '/_authenticated/profile'
    | '/_authenticated/'
    | '/_authenticated/about/$categoryId'
    | '/_authenticated/events/$eventId'
    | '/_authenticated/events/new'
    | '/_authenticated/media/assets'
    | '/_authenticated/persons/fans'
    | '/_authenticated/persons/users'
    | '/_authenticated/users/$userId'
    | '/_authenticated/website/$pageId'
    | '/_authenticated/website/navigation'
    | '/_authenticated/about/'
    | '/_authenticated/checkins/'
    | '/_authenticated/events/'
    | '/_authenticated/persons/'
    | '/_authenticated/reservations/'
    | '/_authenticated/settings/'
    | '/_authenticated/tickets/'
    | '/_authenticated/users/'
    | '/_authenticated/website/'
    | '/_authenticated/website/$pageId/$sectionId'
    | '/_authenticated/website/$pageId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  SignInRoute: typeof SignInRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-in': {
      id: '/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof SignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/audit-log': {
      id: '/_authenticated/audit-log'
      path: '/audit-log'
      fullPath: '/audit-log'
      preLoaderRoute: typeof AuthenticatedAuditLogRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/changelog': {
      id: '/_authenticated/changelog'
      path: '/changelog'
      fullPath: '/changelog'
      preLoaderRoute: typeof AuthenticatedChangelogRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/discord': {
      id: '/_authenticated/discord'
      path: '/discord'
      fullPath: '/discord'
      preLoaderRoute: typeof AuthenticatedDiscordRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/event-categories': {
      id: '/_authenticated/event-categories'
      path: '/event-categories'
      fullPath: '/event-categories'
      preLoaderRoute: typeof AuthenticatedEventCategoriesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/feature-requests': {
      id: '/_authenticated/feature-requests'
      path: '/feature-requests'
      fullPath: '/feature-requests'
      preLoaderRoute: typeof AuthenticatedFeatureRequestsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/mail': {
      id: '/_authenticated/mail'
      path: '/mail'
      fullPath: '/mail'
      preLoaderRoute: typeof AuthenticatedMailRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/profile': {
      id: '/_authenticated/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof AuthenticatedProfileRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/about/': {
      id: '/_authenticated/about/'
      path: '/about'
      fullPath: '/about/'
      preLoaderRoute: typeof AuthenticatedAboutIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/about/$categoryId': {
      id: '/_authenticated/about/$categoryId'
      path: '/about/$categoryId'
      fullPath: '/about/$categoryId'
      preLoaderRoute: typeof AuthenticatedAboutCategoryIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/checkins/': {
      id: '/_authenticated/checkins/'
      path: '/checkins'
      fullPath: '/checkins/'
      preLoaderRoute: typeof AuthenticatedCheckinsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/events/': {
      id: '/_authenticated/events/'
      path: '/events'
      fullPath: '/events/'
      preLoaderRoute: typeof AuthenticatedEventsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/events/$eventId': {
      id: '/_authenticated/events/$eventId'
      path: '/events/$eventId'
      fullPath: '/events/$eventId'
      preLoaderRoute: typeof AuthenticatedEventsEventIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/events/new': {
      id: '/_authenticated/events/new'
      path: '/events/new'
      fullPath: '/events/new'
      preLoaderRoute: typeof AuthenticatedEventsNewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/media/assets': {
      id: '/_authenticated/media/assets'
      path: '/media/assets'
      fullPath: '/media/assets'
      preLoaderRoute: typeof AuthenticatedMediaAssetsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/persons/': {
      id: '/_authenticated/persons/'
      path: '/persons'
      fullPath: '/persons/'
      preLoaderRoute: typeof AuthenticatedPersonsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/persons/fans': {
      id: '/_authenticated/persons/fans'
      path: '/persons/fans'
      fullPath: '/persons/fans'
      preLoaderRoute: typeof AuthenticatedPersonsFansRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/persons/users': {
      id: '/_authenticated/persons/users'
      path: '/persons/users'
      fullPath: '/persons/users'
      preLoaderRoute: typeof AuthenticatedPersonsUsersRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/reservations/': {
      id: '/_authenticated/reservations/'
      path: '/reservations'
      fullPath: '/reservations/'
      preLoaderRoute: typeof AuthenticatedReservationsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings/': {
      id: '/_authenticated/settings/'
      path: '/settings'
      fullPath: '/settings/'
      preLoaderRoute: typeof AuthenticatedSettingsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/tickets/': {
      id: '/_authenticated/tickets/'
      path: '/tickets'
      fullPath: '/tickets/'
      preLoaderRoute: typeof AuthenticatedTicketsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/users/': {
      id: '/_authenticated/users/'
      path: '/users'
      fullPath: '/users/'
      preLoaderRoute: typeof AuthenticatedUsersIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/users/$userId': {
      id: '/_authenticated/users/$userId'
      path: '/users/$userId'
      fullPath: '/users/$userId'
      preLoaderRoute: typeof AuthenticatedUsersUserIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/website/': {
      id: '/_authenticated/website/'
      path: '/website'
      fullPath: '/website/'
      preLoaderRoute: typeof AuthenticatedWebsiteIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/website/$pageId': {
      id: '/_authenticated/website/$pageId'
      path: '/website/$pageId'
      fullPath: '/website/$pageId'
      preLoaderRoute: typeof AuthenticatedWebsitePageIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/website/navigation': {
      id: '/_authenticated/website/navigation'
      path: '/website/navigation'
      fullPath: '/website/navigation'
      preLoaderRoute: typeof AuthenticatedWebsiteNavigationRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/website/$pageId/': {
      id: '/_authenticated/website/$pageId/'
      path: '/'
      fullPath: '/website/$pageId/'
      preLoaderRoute: typeof AuthenticatedWebsitePageIdIndexRouteImport
      parentRoute: typeof AuthenticatedWebsitePageIdRoute
    }
    '/_authenticated/website/$pageId/$sectionId': {
      id: '/_authenticated/website/$pageId/$sectionId'
      path: '/$sectionId'
      fullPath: '/website/$pageId/$sectionId'
      preLoaderRoute: typeof AuthenticatedWebsitePageIdSectionIdRouteImport
      parentRoute: typeof AuthenticatedWebsitePageIdRoute
    }
  }
}

interface AuthenticatedWebsitePageIdRouteChildren {
  AuthenticatedWebsitePageIdSectionIdRoute: typeof AuthenticatedWebsitePageIdSectionIdRoute
  AuthenticatedWebsitePageIdIndexRoute: typeof AuthenticatedWebsitePageIdIndexRoute
}

const AuthenticatedWebsitePageIdRouteChildren: AuthenticatedWebsitePageIdRouteChildren =
  {
    AuthenticatedWebsitePageIdSectionIdRoute:
      AuthenticatedWebsitePageIdSectionIdRoute,
    AuthenticatedWebsitePageIdIndexRoute: AuthenticatedWebsitePageIdIndexRoute,
  }

const AuthenticatedWebsitePageIdRouteWithChildren =
  AuthenticatedWebsitePageIdRoute._addFileChildren(
    AuthenticatedWebsitePageIdRouteChildren,
  )

interface AuthenticatedRouteChildren {
  AuthenticatedAuditLogRoute: typeof AuthenticatedAuditLogRoute
  AuthenticatedChangelogRoute: typeof AuthenticatedChangelogRoute
  AuthenticatedDiscordRoute: typeof AuthenticatedDiscordRoute
  AuthenticatedEventCategoriesRoute: typeof AuthenticatedEventCategoriesRoute
  AuthenticatedFeatureRequestsRoute: typeof AuthenticatedFeatureRequestsRoute
  AuthenticatedMailRoute: typeof AuthenticatedMailRoute
  AuthenticatedProfileRoute: typeof AuthenticatedProfileRoute
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
  AuthenticatedAboutCategoryIdRoute: typeof AuthenticatedAboutCategoryIdRoute
  AuthenticatedEventsEventIdRoute: typeof AuthenticatedEventsEventIdRoute
  AuthenticatedEventsNewRoute: typeof AuthenticatedEventsNewRoute
  AuthenticatedMediaAssetsRoute: typeof AuthenticatedMediaAssetsRoute
  AuthenticatedPersonsFansRoute: typeof AuthenticatedPersonsFansRoute
  AuthenticatedPersonsUsersRoute: typeof AuthenticatedPersonsUsersRoute
  AuthenticatedUsersUserIdRoute: typeof AuthenticatedUsersUserIdRoute
  AuthenticatedWebsitePageIdRoute: typeof AuthenticatedWebsitePageIdRouteWithChildren
  AuthenticatedWebsiteNavigationRoute: typeof AuthenticatedWebsiteNavigationRoute
  AuthenticatedAboutIndexRoute: typeof AuthenticatedAboutIndexRoute
  AuthenticatedCheckinsIndexRoute: typeof AuthenticatedCheckinsIndexRoute
  AuthenticatedEventsIndexRoute: typeof AuthenticatedEventsIndexRoute
  AuthenticatedPersonsIndexRoute: typeof AuthenticatedPersonsIndexRoute
  AuthenticatedReservationsIndexRoute: typeof AuthenticatedReservationsIndexRoute
  AuthenticatedSettingsIndexRoute: typeof AuthenticatedSettingsIndexRoute
  AuthenticatedTicketsIndexRoute: typeof AuthenticatedTicketsIndexRoute
  AuthenticatedUsersIndexRoute: typeof AuthenticatedUsersIndexRoute
  AuthenticatedWebsiteIndexRoute: typeof AuthenticatedWebsiteIndexRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedAuditLogRoute: AuthenticatedAuditLogRoute,
  AuthenticatedChangelogRoute: AuthenticatedChangelogRoute,
  AuthenticatedDiscordRoute: AuthenticatedDiscordRoute,
  AuthenticatedEventCategoriesRoute: AuthenticatedEventCategoriesRoute,
  AuthenticatedFeatureRequestsRoute: AuthenticatedFeatureRequestsRoute,
  AuthenticatedMailRoute: AuthenticatedMailRoute,
  AuthenticatedProfileRoute: AuthenticatedProfileRoute,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedAboutCategoryIdRoute: AuthenticatedAboutCategoryIdRoute,
  AuthenticatedEventsEventIdRoute: AuthenticatedEventsEventIdRoute,
  AuthenticatedEventsNewRoute: AuthenticatedEventsNewRoute,
  AuthenticatedMediaAssetsRoute: AuthenticatedMediaAssetsRoute,
  AuthenticatedPersonsFansRoute: AuthenticatedPersonsFansRoute,
  AuthenticatedPersonsUsersRoute: AuthenticatedPersonsUsersRoute,
  AuthenticatedUsersUserIdRoute: AuthenticatedUsersUserIdRoute,
  AuthenticatedWebsitePageIdRoute: AuthenticatedWebsitePageIdRouteWithChildren,
  AuthenticatedWebsiteNavigationRoute: AuthenticatedWebsiteNavigationRoute,
  AuthenticatedAboutIndexRoute: AuthenticatedAboutIndexRoute,
  AuthenticatedCheckinsIndexRoute: AuthenticatedCheckinsIndexRoute,
  AuthenticatedEventsIndexRoute: AuthenticatedEventsIndexRoute,
  AuthenticatedPersonsIndexRoute: AuthenticatedPersonsIndexRoute,
  AuthenticatedReservationsIndexRoute: AuthenticatedReservationsIndexRoute,
  AuthenticatedSettingsIndexRoute: AuthenticatedSettingsIndexRoute,
  AuthenticatedTicketsIndexRoute: AuthenticatedTicketsIndexRoute,
  AuthenticatedUsersIndexRoute: AuthenticatedUsersIndexRoute,
  AuthenticatedWebsiteIndexRoute: AuthenticatedWebsiteIndexRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  SignInRoute: SignInRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
